import CreateRole  from "../../../../component/userMaster/createRole";

const Create=()=>{
    return <CreateRole/>
};
export default Create;